import { Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

import { InformationSection as SharedInformationSection } from 'shared/components/Disclaimer';
import { PolicyLink } from 'shared/components/PolicyLink';

import type { FC } from 'react';

export const InformationSection: FC = () => {
  const { t } = useTranslation();

  return (
    <SharedInformationSection>
      <Typography marginTop={2} marginBottom={2} variant="h6">
        {t('GSP.pages.parentHelper.disclaimer.header')}
      </Typography>
      <Typography variant="body1">
        <Trans i18nKey="GSP.pages.parentHelper.disclaimer.description.p1" />
      </Typography>
      <Typography variant="body1">
        <Trans i18nKey="GSP.pages.parentHelper.disclaimer.description.p2" />
      </Typography>
      <Typography variant="body1">
        <Trans
          components={{ a: <PolicyLink target="_blank" /> }}
          i18nKey="GSP.pages.parentHelper.disclaimer.description.p3"
        />
      </Typography>
      <Typography variant="body1">
        <Trans
          components={{ a: <PolicyLink target="_blank" /> }}
          i18nKey="GSP.pages.parentHelper.disclaimer.description.p4"
        />
      </Typography>
    </SharedInformationSection>
  );
};
